import { faBars, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppLayout, IconButton, Stack, useAppLayoutContext } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IHeaderProps = IContainerProps & {
  //
};

const styles = stylex.create({
  host: {
    zIndex: 0,
  },
});

export const Header: React.FC<IHeaderProps> = (props) => {
  const { sx } = props;
  const appLayoutContext = useAppLayoutContext();

  const navigationDrawerOpened =
    appLayoutContext.navigationDrawer?.state?.opened;
  const shouldShowNavigationDrawerToggle =
    !navigationDrawerOpened && appLayoutContext.navigationMode !== 'rail';

  return (
    <AppLayout.Header sx={[styles.host, sx]}>
      <Stack horizontal gap={6} justify="space-between" grow>
        <Stack horizontal gap={2}>
          {shouldShowNavigationDrawerToggle ? (
            <IconButton
              icon={
                <FontAwesomeIcon
                  icon={
                    appLayoutContext.navigationDrawer?.state?.opened
                      ? faXmark
                      : faBars
                  }
                />
              }
              onClick={appLayoutContext.navigationDrawer?.state?.toggle}
            />
          ) : null}
        </Stack>

        <Stack horizontal gap={2}>
          {appLayoutContext.aside?.state?.toggle ? (
            <IconButton
              icon={
                <FontAwesomeIcon
                  icon={
                    appLayoutContext.aside?.state?.opened ? faXmark : faBars
                  }
                />
              }
              onClick={appLayoutContext.aside?.state?.toggle}
            />
          ) : null}
        </Stack>
      </Stack>
    </AppLayout.Header>
  );
};
